import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const WA_URL = 'https://wa.me/5491135779682';
export function WhatsAppButton() {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  useEffect(() => {
    function handleScroll() {
      setShowMobileCTA(window.scrollY > 700);
    }
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* WhatsApp FAB */}
      <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform md:bottom-8 md:right-8" aria-label="Contactar por WhatsApp" data-id="element-256">
        <MessageCircleIcon className="w-7 h-7 text-white" data-id="element-257" />
      </a>

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-258">
        {showMobileCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-navy-dark/95 backdrop-blur-sm border-t border-gold/20 p-3" style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
      }} data-id="element-259">
            <a href={KIT_URL} className="btn-gold block w-full text-center py-3.5 rounded-xl font-extrabold text-sm no-underline" data-id="element-260">
              Kit Completo — $62.900 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </>;
}